const moduleName = 'measurementValidator';

import { components, reducers } from 'linksoft';

import measurementValidator from './measurement-validator';
import reducer from './store/reducer';

components.add('measurement-validator', measurementValidator);
reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [measurementValidator],
    reducer: { reducer }
};


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/index.js